import { render } from "./ModalEditarMarca.vue?vue&type=template&id=78c06c41&scoped=true&ts=true"
import script from "./ModalEditarMarca.vue?vue&type=script&lang=ts"
export * from "./ModalEditarMarca.vue?vue&type=script&lang=ts"

import "./ModalEditarMarca.vue?vue&type=style&index=0&id=78c06c41&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c06c41"]])

export default __exports__